import React, { FunctionComponent, useEffect } from 'react';
import { Switch } from 'react-router-dom';
import MakeSubRoutes from './makeSubRoutes';
import { webViewRoutes } from './routes';
import { useLocale } from '../context/localization';
import { webViewtheme } from '../utils/theme';
import { getQueryParams, setToken, setLocale } from '../utils/utils';
import { ThemeProvider } from 'styled-components';
import { buildDate } from '../utils/buildInfo';

const WebViews: FunctionComponent<any> = () => {
  const locale = useLocale();
  useEffect(() => {
    console.log('Build Code: ' + buildDate);

    const params = getQueryParams();
    const accessToken = params.token;
    // const locale = params.locale;
    if (!!accessToken) {
      setToken(accessToken);
    }
    // if (!!locale) {
    //   setLocale(locale);
    // }
  }, [locale]);

  return (
    <div>
      <ThemeProvider theme={webViewtheme}>
        <Switch>
          {webViewRoutes.map((route: object, index: number) => (
            <MakeSubRoutes key={index} {...route} locale={locale} />
          ))}
        </Switch>
      </ThemeProvider>
    </div>
  );
};

export default WebViews;
